import React from 'react';
import { makeStyles } from '@mui/styles';
import { User } from '../../../../../../models/interfaces/User.interface';
import ProductFormComponent from '../../components/product-form/product-form.component';
import { Link, useOutletContext } from 'react-router-dom';
import { ProductCategory } from '../../../../../../models/interfaces/ProductCategory.interface';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import routeService from '../../../../../../routes/route.service';

const useStyles = makeStyles({
  title: {
    fontSize: '20px',
    marginBottom: '20px',
  },
});

export default function ProductCreateComponent() {
  const { user, businessObject, category } = useOutletContext<{
    user: User;
    businessObject: BusinessObject;
    category: ProductCategory;
  }>();

  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>Create new product</div>

      <ProductFormComponent
        ownerId={user?.id}
        ownerEmail={user?.email}
        businessObjectId={businessObject?.id}
        categoryId={category?.id}
      />

      <Link to={routeService.getAndFillCategoryDetailPath(user?.id, businessObject?.id, category?.id)}>
        Back to category
      </Link>
    </div>
  );
}
